import React from 'react'
import { Row, Col, Card } from 'react-bootstrap'
import Contacto from './Contacto'
import AyudaContenido from './AyudaContenido'
import { ToastContainer } from 'react-toastify'
import { INTERVALO_CORTO } from '../../../../config/settings'

function Ayuda () {
  return (
    <>
      <ToastContainer autoClose={INTERVALO_CORTO} />
      <h2 style={{ marginTop: '-3%' }}>Ayuda</h2>
      <Row style={{ margin: '3% 0' }} >
        <Col md={7}>
          <Card className='shadow bg-white rounded' style={{ height: '100%' }} >
            <AyudaContenido />
          </Card>
        </Col>
        <Col md={5}>
          <Card className='shadow bg-white rounded' style={{ height: '100%' }}>
            <Contacto />
          </Card>
        </Col>
      </Row>

    </>
  )
}

export default Ayuda
